export const canUseOfferAsTemplate = (offer) => {
  return Boolean(offer?.tab_data?.settings && typeof offer.tab_data.settings === 'object');
};

export const buildTemplateTabName = (offer) => {
  const sourceName = offer?.tab_data?.name || offer?.metadata?.client_name || 'Offer';
  return `Copy - ${sourceName}`;
};

export const getOfferTemplateRegion = (offer) => {
  return offer?.region || offer?.pricing_snapshot?.region || offer?.pricingSnapshot?.region || null;
};

export const getComparisonTemplateRegion = (comparison) => {
  return comparison?.region || getOfferTemplateRegion(comparison?.offers?.[0]) || null;
};

export const buildCalculatorTemplateUrl = (tabId, origin = window.location.origin) => {
  return `${origin}/?activeTab=${encodeURIComponent(tabId)}`;
};

const cloneSettings = (settings) => JSON.parse(JSON.stringify(settings || {}));

export const buildOfferTemplatePayload = (offer, source = null) => {
  if (!canUseOfferAsTemplate(offer)) {
    return null;
  }

  return {
    name: buildTemplateTabName(offer),
    settings: {
      ...cloneSettings(offer.tab_data.settings),
      _templateSource: source || {
        type: 'offer',
        id: offer.id,
      },
    },
  };
};

export const buildComparisonTemplatePayloads = (comparison) => {
  const comparisonId = comparison?.id;

  return (comparison?.offers || [])
    .map((offer) => buildOfferTemplatePayload(offer, {
      type: 'comparison',
      id: comparisonId,
      offerId: offer.id,
    }))
    .filter(Boolean);
};
